"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UNKNOWN = exports.UNKNOWN = -1;
var SUCCESS = exports.SUCCESS = 0;
var FAILED = exports.FAILED = 1;


//////////////////
// WEBPACK FOOTER
// ./node_modules/kryfe-lib/es/fetchHelper/consts/responseCodes.js
// module id = 86Lg
// module chunks = 4